import { AvailabilitySlot } from './availability-slots.inferfaces';
import { Establishment, emptyEstablishment } from './establishments.interfaces';
import { OfferTag } from './offer-tags.intefaces';

export interface OfferDetails {
  id: string;
  imageId: string;

  headline: string;
  description: string;
  newAppDescription: string;
  notes: string;

  startDate: string;
  endDate: string;
  maxNumberOfPeople: number;

  contactName: string;
  contactEmail: string;
  contactPhone: string;

  viewsCount: number;
  redemptionsCount: number;
  lastRedeemedAt: string;
  shortLink: string;

  offerTypes: string[];
  clickToBook: ClickToBook;
  bookingUrl: string;

  contractStartDate: string;
  contractRenewalDate: string;
  contractPaymentPeriod: OfferContractPaymentPeriodEnum;
  listingFee: number;
  groupName: string;

  numberOfCovers: number;
  averageSpendPerHead: number;

  featured: boolean;
  hasPartySize: boolean;
  offerType: OfferTypeEnum;
  redemptionUrl: string;

  reservationType: ReservationType;
  establishment: Establishment;
  offerAvailabilitySlots: AvailabilitySlot[];

  offerTags: OfferTag[];
  price: number;
  status: OfferStatus;

  changedAt: string;
}

export enum OfferStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
}

export enum ReservationType {
  RESERVATION_REQUIRED = 'RESERVATION_REQUIRED',
  WALK_IN_OR_RESERVATION = 'WALK_IN_OR_RESERVATION',
  WALK_IN_ONLY = 'WALK_IN_ONLY',
}

export enum ClickToBook {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  WEBSITE = 'WEBSITE',
}

export enum OfferTypeEnum {
  LOCATION_BASED = 'LOCATION_BASED',
  LINK_BASED = 'LINK_BASED',
}

export enum OfferContractPaymentPeriodEnum {
  ANNUAL_PAYMENT = 'ANNUAL_PAYMENT',
  MONTHLY_PAYMENT = 'MONTHLY_PAYMENT',
  FREE_LISTING = 'FREE_LISTING',
  COMMISSION = 'COMMISSION'
}

export enum OfferTypeLabelEnum {
  LOCATION_BASED = 'LOCATION',
  LINK_BASED = 'LINK',
}

export interface OfferSummary {
  id: string;

  headline: string;
  maxNumberOfPeople: number;
  startDate: string;
  endDate: string;

  contactName: string;
  contactEmail: string;
  contactPhone: string;

  establishmentName: string;
  address: string;

  email: string;
  phone: string;
  website: string;
  bookingUrl: string;
  twitter: string;
  instagram: string;
  description: string;

  reservationType: ReservationType;
  clickToBook: ClickToBook;

  latitude: number;
  longitude: number;

  locationName: string;
  neighbourhood: string;
  city: string;
  country: string;

  typeNames: string[];

  redemptionsCount: number;
  viewsCount: number;
  lastRedeemedAt: string;
  lastViewedAt: string;

  status: OfferStatus;
}

export interface OfferType {
  id: string;
  name: string;
}

export function emptyOfferDetails(): OfferDetails {
  return {
    id: null,
    imageId: null,

    headline: null,
    description: null,
    newAppDescription: null,
    notes: null,

    startDate: null,
    endDate: null,

    maxNumberOfPeople: null,

    contactName: null,
    contactEmail: null,
    contactPhone: null,

    viewsCount: null,
    redemptionsCount: null,
    lastRedeemedAt: null,
    shortLink: null,
    bookingUrl: null,

    featured: false,
    hasPartySize: false,
    offerType: null,
    redemptionUrl: null,

    offerTypes: [],
    clickToBook: null,
    reservationType: null,
    establishment: emptyEstablishment(),
    offerAvailabilitySlots: [],

    contractStartDate: null,
    contractRenewalDate: null,
    contractPaymentPeriod: null,
    listingFee: null,
    groupName: null,

    numberOfCovers: null,
    averageSpendPerHead: null,

    offerTags: [],
    price: null,
    status: OfferStatus.DRAFT,

    changedAt: null,
  };
}

export interface SymbolResponse {
  symbol: string;
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/interfaces/offer.interfaces.ts